module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/yellow-6a8c0059ab2846ac31e9c9548d5218f2.png";